import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { ExternalLink } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-foreground text-white mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <AppLogo size={36} />
              <span className="font-extrabold text-lg">
                Chisme<span className="text-primary">y</span>Tejidos
              </span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              El chisme más caliente, tejido con amor 🧶<br />
              La comunidad chileno - venezolana donde todos cuentan todo.
            </p>
            <div className="flex items-center gap-3 mt-2">
              <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-primary/30 transition-colors" aria-label="Instagram">
                <ExternalLink size={18} />
              </a>
              <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-primary/30 transition-colors" aria-label="YouTube">
                <ExternalLink size={18} />
              </a>
              <a href="#" className="p-2 rounded-full bg-white/10 hover:bg-primary/30 transition-colors" aria-label="TikTok">
                <ExternalLink size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-widest text-white/40 mb-4">Navegar</h4>
            <div className="flex flex-col gap-2">
              {[
                { href: '/', label: 'Inicio' },
                { href: '/live-stream-screen', label: 'En Vivo' },
                { href: '/sign-up-login-screen', label: 'Seguir el Canal' },
                { href: '/host-admin-panel', label: 'Panel Anfitriona' },
              ]?.map((link) => (
                <Link
                  key={`footer-${link?.label}`}
                  href={link?.href}
                  className="text-sm text-white/60 hover:text-primary transition-colors"
                >
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Privacy */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-widest text-white/40 mb-4">Privacidad</h4>
            <p className="text-sm text-white/60 leading-relaxed">
              Todos los chismes son 100% anónimos. No guardamos IPs ni datos personales de quienes envían chismes. 🔒
            </p>
            <p className="text-xs text-white/30 mt-3">
              Los chismes son enviados por la comunidad y no representan la opinión de ChismeYTejidos.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-white/40">
            © 2026 ChismeYTejidos.cl — Hecho con 🧶 y mucho chisme en Chile
          </p>
          <p className="text-xs text-white/30">
            chismeytejidos.cl
          </p>
        </div>
      </div>
    </footer>
  );
}